export default {"src":"/_next/static/media/assign.571e628c.svg","height":215,"width":229,"blurWidth":0,"blurHeight":0};